module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright-index"
  }, [_c('xi-top'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "pass_audit_logo.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("资料正在审核中，请耐心等待")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('xi-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-nav-wrapper"
  }, [_c('div', {
    staticClass: "item active"
  }, [_c('i', {
    staticClass: "icon icon-32 icon-flow-01"
  }), _vm._v(" "), _c('span', {}, [_vm._v("注册账户")])]), _vm._v(" "), _c('span', [_vm._v("————————")]), _vm._v(" "), _c('div', {
    staticClass: "item active"
  }, [_c('i', {
    staticClass: "icon icon-32 icon-flow-02"
  }), _vm._v(" "), _c('span', [_vm._v("填写资料")])]), _vm._v(" "), _c('span', [_vm._v("————————")]), _vm._v(" "), _c('div', {
    staticClass: "item active"
  }, [_c('i', {
    staticClass: "icon icon-32 icon-flow-03"
  }), _vm._v(" "), _c('span', [_vm._v("等待审核")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("您可移驾到"), _c('a', {
    staticStyle: {
      "color": "#fc5832"
    },
    attrs: {
      "href": "http://www.ximalaya.com",
      "target": "_blank"
    }
  }, [_vm._v("喜马拉雅FM")]), _vm._v("去放松一下")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20533b1c!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/ApplyWaiting.vue
// module id = 1044
// module chunks = 0